import { FocusEvent, FocusEventHandler, FormEvent, useEffect } from 'react'

import { VendiaFormApi } from './form'

export const onBlurHandler = (field: any, onBlur?: FocusEventHandler) => (e: FocusEvent) => {
  if (onBlur) {
    onBlur(e)
  }
  field.handleBlur()
}

export const onChangeHandler =
  <T = string | number>(field: any, onChange?: (value: T, previousValue?: T) => void) =>
  (value: T) => {
    // Clear all errors when the value changes
    field.setMeta({ ...field.state.meta, errors: [], errorMap: {} })
    if (onChange) {
      onChange(value, field.state.value)
    }
    field.handleChange(value)
  }

export const submitHandler = (form: VendiaFormApi<any>) => (e: FormEvent) => {
  e.preventDefault()
  e.stopPropagation()
  form.handleSubmit()
}

export const useRemoveFieldOnUnmount = (form: VendiaFormApi<any>, name: string, removeFieldOnUnmount = false) => {
  useEffect(() => {
    return () => {
      if (removeFieldOnUnmount) {
        // Remove from form when unmounted
        form.deleteField(name)
      }
    }
  }, [])
}
